(ns global.endor.checkout.ui.components.spinner
  (:require [uix.core :as uix :refer [defui $]]))

(defui spinner
  [{:keys [size color] :or {size 30 color "lightgrey"}}]
  (let [spinner-style {:width (str size "px")
                       :height (str size "px")
                       :border "4px solid black"
                       :border-top (str "4px solid " color)
                       :border-radius "50%"
                       :animation "spin 1s linear infinite"}]
    ($ :div {:style {:display "flex"
                     :justify-content "center"
                     :align-items "center"}}
       ($ :div {:style spinner-style})
       ($ :style nil
          "@keyframes spin {
           0% { transform: rotate(0deg); }
           100% { transform: rotate(360deg); }
           }"))))
